export default __webpack_public_path__ + "static/media/Elio-15.e34b09d9.jpg";